import React, { createContext, useContext, useState } from "react";
import CustomizeGlobalContextProps, { Job } from "./types/types";
import useInterstitialMachine from "./machine/interstitial/use";

const initialData = {};

const CustomizeGlobalContext = createContext(
	initialData as CustomizeGlobalContextProps,
);

export const CustomizeGlobalProvider = (props: any) => {
	const [newDemo, setNewDemo] = useState<Job | undefined>();
	const [state, send, service] = useInterstitialMachine();

	const context: CustomizeGlobalContextProps = {
		Customize: {
			demo: {
				new: {
					payload: newDemo,
					setPayload: (job: Job) => {
						setNewDemo({ ...job, notification: true });
					},
					resetPayload: () => {
						setNewDemo(undefined);
					},
				},
			},
			machine: { state, send, service },
		},
	};
	return (
		<CustomizeGlobalContext.Provider value={context}>
			{props.children}
		</CustomizeGlobalContext.Provider>
	);
};

export const useCustomizeGlobalContext = () =>
	useContext(CustomizeGlobalContext);
